import { EQuizStatsDateFilterValue, EQuizStatsDateInterval } from '@constants';
import { create } from 'zustand';

interface IStore {
  dateFilter: EQuizStatsDateFilterValue;
  setDateFilter: (dateFilter: EQuizStatsDateFilterValue) => void;
  dateInterval: EQuizStatsDateInterval;
  setDateInterval: (dateInterval: EQuizStatsDateInterval) => void;
}

export const useQuizStatsFilters = create<IStore>(set => ({
  dateFilter: EQuizStatsDateFilterValue.WEEK,
  setDateFilter: dateFilter => set({ dateFilter }),
  dateInterval: EQuizStatsDateInterval.WEEK,
  setDateInterval: dateInterval => set({ dateInterval })
}));
